export default {"src":"/_next/static/media/save-time.3f3e5cbb.svg","height":32,"width":32};